import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./TravelInsurance.css";

const COVERAGE = [
  {
    id: "cancellation",
    title: "Trip Cancellation",
    limit: "$2K–$5K",
    desc: "Covers non-refundable expenses if trip is canceled",
  },
  {
    id: "delay",
    title: "Travel Delay",
    limit: "$200–$500",
    desc: "Meals & accommodation for 6–12h+ delays",
  },
  {
    id: "baggage",
    title: "Baggage Delay / Loss",
    limit: "$100–$3K",
    desc: "Reimbursement for delayed, lost, or stolen baggage",
  },
  {
    id: "emergency-medical",
    title: "Emergency Medical",
    limit: "$100K–$500K",
    desc: "24/7 emergency medical coverage worldwide",
    route: "/emergency-medical",
  },
  {
    id: "accident",
    title: "Travel Accident",
    limit: "$250K–$500K",
    desc: "Covers serious injury or death during travel",
  },
  {
    id: "rental",
    title: "Rental Car Insurance",
    limit: "Secondary",
    desc: "Covers damage or theft of rental vehicle",
  },
  {
    id: "assistance",
    title: "24/7 Travel Assistance",
    limit: "Unlimited",
    desc: "Round-the-clock support anywhere in the world",
  },
];

const WHO_COVERED = ["Cardholder", "Spouse", "Dependent children traveling with you"];

export default function TravelInsurance() {
  const [showImportant, setShowImportant] = useState(false);

  return (
    <div className="travel-ins-page">
      <Link to="/benefits" className="back-link">← Benefits</Link>

      <section className="travel-ins-hero">
        <h1 className="travel-ins-title">Travel Insurance</h1>
        <p className="travel-ins-subtitle">Automatically activated when you pay with your card. No registration needed.</p>
      </section>

      <div className="travel-ins-highlights">
        <div className="travel-ins-highlight">
          <span className="highlight-value">90</span>
          <span className="highlight-label">Days / trip</span>
        </div>
        <div className="travel-ins-highlight">
          <span className="highlight-value">$500K</span>
          <span className="highlight-label">Medical</span>
        </div>
        <div className="travel-ins-highlight">
          <span className="highlight-value">$5K</span>
          <span className="highlight-label">Cancellation</span>
        </div>
      </div>

      {/* Who's covered */}
      <section className="travel-ins-section">
        <h3 className="travel-ins-section-title">Who's Covered</h3>
        <div className="travel-ins-who">
          {WHO_COVERED.map((person, i) => (
            <span key={i} className="who-pill">✓ {person}</span>
          ))}
        </div>
      </section>

      {/* Coverage cards */}
      <section className="travel-ins-section">
        <h3 className="travel-ins-section-title">What's Covered</h3>
        <div className="coverage-list">
          {COVERAGE.map((c) => (
            <Link
              key={c.id}
              to={c.route || `/travel-insurance/${c.id}`}
              className="coverage-card"
            >
              <div className="coverage-info">
                <span className="coverage-title">{c.title}</span>
                <span className="coverage-desc">{c.desc}</span>
              </div>
              <div className="coverage-right">
                <span className="coverage-limit">{c.limit}</span>
                <span className="coverage-chevron">›</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Important information — collapsed by default */}
      <section className="travel-ins-section">
        <button
          className="important-tag"
          onClick={() => setShowImportant(!showImportant)}
          type="button"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4" />
            <circle cx="12" cy="16" r="0.5" fill="currentColor" />
          </svg>
          <span>Important Information</span>
          <span className={`important-chevron ${showImportant ? "open" : ""}`}>›</span>
        </button>
        {showImportant && (
          <div className="important-body">
            <p className="important-text">Visa Platinum provides mid-tier coverage — less comprehensive than Visa Signature or Visa Infinite.</p>
            <p className="important-text">Limits are moderate and may not be sufficient alone for expensive or long trips. Consider supplementary travel insurance for higher limits.</p>
          </div>
        )}
      </section>

      <div className="travel-ins-bottom">
        <span className="bottom-check">✓ Included</span>
        <span className="bottom-dot">·</span>
        <span className="bottom-check">✓ No extra cost</span>
        <span className="bottom-dot">·</span>
        <span className="bottom-check">✓ Auto-activated</span>
      </div>

      <div className="travel-ins-close-wrap">
        <Link to="/benefits" className="travel-ins-close">Close</Link>
      </div>

      <footer className="powered-by">Powered by Visa</footer>
    </div>
  );
}
